var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.25 10.125C18.25 11.1397 17.872 12.2874 17.2431 13.4778C16.6188 14.6595 15.7773 15.8272 14.9211 16.867C14.0667 17.9043 13.2103 18.7992 12.5666 19.4353C12.3505 19.6488 12.1589 19.8326 12 19.9824C11.8411 19.8326 11.6495 19.6488 11.4334 19.4353C10.7897 18.7992 9.93326 17.9043 9.07895 16.867C8.22268 15.8272 7.38121 14.6595 6.7569 13.4778C6.12801 12.2874 5.75 11.1397 5.75 10.125C5.75 7.92314 6.47093 6.35234 7.56319 5.32842C8.66406 4.29642 10.2172 3.75 12 3.75C13.7828 3.75 15.3359 4.29642 16.4368 5.32842C17.5291 6.35234 18.25 7.92314 18.25 10.125Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 10,
    r: 2.25,
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.257384b111f441294cccbf7fe161efdb.svg";
export { ForwardRef as ReactComponent };